import axios from 'axios'

const http = axios.create({
	xsrfCookieName: 'csrftoken',
	xsrfHeaderName: 'X-CSRFToken'
})

http.interceptors.response.use(function (response) {
	return response
}, function (error) {
	// redirect 403 to login page
	if (error.response) {
		if (error.response.status === 403) {
			window.location.replace('/unauthorized/')
		} else if (error.response.status === 404) {
			window.location.replace('/not-found/')
		}
	}
	return Promise.reject(error)
})

export default http
